const initialState = {
  Data: [],
  showLoading: false,
  loggedInAgent: {},
  loggedInOrgSettings: {},
  isAgentAdded: "",
  singleAgent: {},
  saveProfile: "",
  saveOrgProfile: "",
  notificationList: "",
  groupWithTicketCount:[]
};

const agentReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case "successCall":
      return {
        ...state,
        isAgentAdded: action.payload,
      };
    case "getAgent":
      return {
        ...state,
        Data: action.payload,
      };
    case "saveProfile":
      return {
        ...state,
        saveProfile: action.payload,
      };
    case "saveOrgProfile":
      return {
        ...state,
        saveOrgProfile: action.payload,
      };
    case "singleAgent":
      return {
        ...state,
        singleAgent: action.payload,
      };
    case "LOGGED_IN_AGENT":
      return {
        ...state,
        loggedInAgent: action.payload,
      };
    case "LOGGED_IN_AGENT_ORGANISATION_SETTING":
      return {
        ...state,
        loggedInOrgSettings: action.payload,
      };
    case "updateAgent":
    case "multipalUpdateAgent":
    case "softDeleteAgent":
      return {
        ...state,
      };
    case "deleteAgent":
      return {
        ...state,
      };
    case "loading":
      return {
        ...state,
        showLoading: action.payload,
      };
    case "AGENT_WITH_TICKET_COUNT":
      return {
        ...state,
        groupWithTicketCount: action.payload,
      };
    case "UPDATE_GROUP_TICKET_COUNT":
      const {
        oldGroupId,
        oldAgentId,
        newGroupId,
        newAgentId,
      } = action.payload;
       return {
    ...state,
    groupWithTicketCount: state.groupWithTicketCount.map((group: any) => {
      let updatedGroup = { ...group };

      if (oldGroupId !== newGroupId) {
        if (group.groupId === oldGroupId) {
          updatedGroup.ticketCount = Math.max(0, group.ticketCount - 1);
        }

        if (group.groupId === newGroupId) {
          updatedGroup.ticketCount = group.ticketCount + 1;
        }
      }

      
      updatedGroup.agents = group.agents.map((agent: any) => {
        let updatedAgent = { ...agent };

        if (oldAgentId !== newAgentId) {
          if (
            group.groupId === oldGroupId &&
            agent.agentId === oldAgentId
          ) {
            updatedAgent.ticketCount = Math.max(
              0,
              agent.ticketCount - 1
            );
          }

          if (
            group.groupId === newGroupId &&
            agent.agentId === newAgentId
          ) {
            updatedAgent.ticketCount = agent.ticketCount + 1;
          }
        }

        return updatedAgent;
      });

      return updatedGroup;
    }),
  };
    default:
      return state;
  }
};

export default agentReducer;
